import { DependencyList, useEffect } from 'react';
import { Subscription } from 'rxjs';

export const useSubscription = (subscriber: () => Subscription, deps: DependencyList = []) =>
  useEffect(() => {
    const sub = subscriber();
    return () => sub.unsubscribe();
  }, deps);
